import { currencyFormat } from "../../../../utils/media";

export const setRenewalTrendsData = (result: any) => {
  if (result?.length > 0) {
    // Extract data
    const pending = result.map((item) => item.AwaitingDecision);
    const declined = result.map((item) => item.Declined);
    const accepted = result.map((item) => item.Accepted);
    // const total = result.map((item) => item.total);
    // array of colors
    // Final chart series
    const chartSeries: any = [
      {
        name: "Pending Renewals",
        type: "bar",
        barWidth: "50%",
        stack: "total",
        data: pending,
        itemStyle: { color: "#3E7A9E" },
      },
      {
        name: "Declined",
        type: "bar",
        barWidth: "50%",
        stack: "total",
        data: declined,
        itemStyle: { color: "#E85D64" },
      },
      {
        name: "Accepted",
        type: "bar",
        barWidth: "50%",
        stack: "total",
        data: accepted,
        itemStyle: { color: "#123A55" },
      },
      // {
      //   tooltip: { show: false }, // hide from tooltip
      //   name: null,
      //   type: "bar",
      //   barWidth: "50%",
      //   stack: "total",
      //   data: total,
      //   itemStyle: { color: "#E1E1E1", borderRadius: [10, 10, 0, 0] },
      // },
    ];

    return chartSeries;
  } else {
    return [];
  }
};

export const setAwaitingDecisionData = (result: any) => {
  let totoalPendingCount = 0;
  let totalPendingAmount = "0";
  let timeBlocks = [];
  let totalPercentage = 0;

  result?.forEach((element) => {
    if (element?.days === "all") {
      totoalPendingCount = element?.count;
      totalPendingAmount = currencyFormat(element?.amount);
      totalPercentage = element?.percentage;
    } else if (element?.days === "90 days") {
      timeBlocks.push({
        label: element?.days,
        value: element?.count,
        amount: `${currencyFormat(element?.amount)}`,
        color: "#1F5782",
        percent: element?.percentage,
      });
    } else if (element?.days === "60 days") {
      timeBlocks.push({
        label: element?.days,
        value: element?.count,
        amount: `${currencyFormat(element?.amount)}`,
        color: "#417BA2",
        percent: element?.percentage,
      });
    } else if (element?.days === "30 days") {
      timeBlocks.push({
        label: element?.days,
        value: element?.count,
        amount: `${currencyFormat(element?.amount)}`,
        color: "#FF6B6B",
        percent: element?.percentage,
      });
    }
  });

  return {
    totoalPendingCount,
    totalPendingAmount,
    timeBlocks,
    totalPercentage,
  };
};

export const renewalCardsData = (data) => {
  return [
    {
      key: "upcoming-renewals",
      title: "Upcoming Renewals",
      value: data?.upcomingRenewalsCount ? data?.upcomingRenewalsCount : 0,
      extraText: currencyFormat(data?.upcomingRenewalsTotalAmount),
      style: {
        backgroundColor: "#123A55",
        color: "#ffffff",
      },
    },
    {
      key: "renewalsAwaiting",
      title: "Renewals Awaiting",
      value: data?.renewalAwaitingCount ? data?.renewalAwaitingCount : 0,
      extraText: currencyFormat(data?.renewalAwaitingTotalAmount),
      style: {
        backgroundColor: "#ffffff",
        color: "#123A55",
        border: "1px solid #E9E9E9",
      },
    },
    {
      key: "renewed-accepted",
      title: "Renewed Accepted",
      value: data?.renewalAcceptedCount ? data?.renewalAcceptedCount : 0,
      extraText: currencyFormat(data?.renewalAcceptedTotalAmount),
      style: {
        backgroundColor: "#4682A9",
        color: "#ffffff",
      },
    },

    {
      key: "renewalsDeclined",
      title: "Renewals Declined",
      value: data?.renewalDeclinedCount ? data?.renewalDeclinedCount : 0,
      extraText: currencyFormat(data?.renewalDeclinedTotalAmount),
      style: {
        backgroundColor: "#ffffff",
        color: "#123A55",
        border: "1px solid #E9E9E9",
      },
    },
    // {
    //   key: "expiring-in-next-30-days",
    //   title: "Expiring in Next 30 days",
    //   value: "5",
    //   extraText: currencyFormat("345000"),
    //   style: {
    //     backgroundColor: "#F8F8F8",
    //     color: "#123A55",
    //   },
    // },
    // {
    //   key: "expired-leases",
    //   title: "Expired Leases",
    //   value: "3",
    //   extraText: currencyFormat("175000"),
    //   style: {
    //     backgroundColor: "#F8F8F8",
    //     color: "#123A55",
    //   },
    // },
  ];
};
